import { render, staticRenderFns } from "./ComLogin.vue?vue&type=template&id=8056cbae&"
import script from "./ComLogin.vue?vue&type=script&lang=js&"
export * from "./ComLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports